<template>
    <div id="VideoCenter">
    <view1/>
    <view2/>

    </div>

</template>
<script>
    export default {
        name: 'VideoCenter',
        components: {
            // 异步加载子组件
            view1: () => import('@/views/VideoCenter/view1.vue'),
            view2: () => import('@/views/VideoCenter/view2.vue')
        }
    }
</script>
<style scoped>
</style>